import { index, numeric, pgTable, text, timestamp } from "drizzle-orm/pg-core";
import { nanoid } from "nanoid";
import { user } from "./auth";
import { orders } from "./orders";
import { productCategories, products } from "./products";

export const expenseCategories = [
  "facebook_ads",
  "marketing",
  "packaging",
  "shipping_supplies",
  "return_shipping",
  "carrier_shipping",
  "rent",
  "salary",
  "utilities",
  "other",
] as const;

export type ExpenseCategory = (typeof expenseCategories)[number];

export const expenses = pgTable(
  "expenses",
  {
    id: text("id")
      .primaryKey()
      .$defaultFn(() => nanoid()),
    category: text("category").notNull().$type<ExpenseCategory>(),
    amount: numeric("amount", { precision: 12, scale: 2 }).notNull(),
    currency: text("currency").notNull().default("LAK"),
    spentAt: timestamp("spent_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    title: text("title").notNull(),
    vendor: text("vendor"),
    platform: text("platform"),
    campaignName: text("campaign_name"),
    mappedProductId: text("mapped_product_id").references(() => products.id, {
      onDelete: "set null",
    }),
    mappedCategoryId: text("mapped_category_id").references(
      () => productCategories.id,
      { onDelete: "set null" },
    ),
    linkedOrderId: text("linked_order_id").references(() => orders.id, {
      onDelete: "set null",
    }),
    note: text("note"),
    createdBy: text("created_by").references(() => user.id, {
      onDelete: "set null",
    }),
    createdAt: timestamp("created_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
    updatedAt: timestamp("updated_at", {
      withTimezone: true,
      mode: "date",
    }).notNull(),
  },
  (t) => [
    index("expenses_by_spent_at").on(t.spentAt),
    index("expenses_by_category").on(t.category),
    index("expenses_by_campaign").on(t.campaignName),
    index("expenses_by_platform").on(t.platform),
    index("expenses_by_mapped_product").on(t.mappedProductId),
    index("expenses_by_mapped_category").on(t.mappedCategoryId),
    index("expenses_by_linked_order").on(t.linkedOrderId),
  ],
);
